import React, {useState} from 'react';
import {useActions} from "../../hook/useActions";
import styles from './Login.module.scss';
import {useNavigate} from "react-router-dom";
import { useTranslation } from "react-i18next";

const Login: React.FC = () => {
    const [email, setEmail] = useState<string>('');
    const [password, setPassword] = useState<string>('');
    const [isRemember, setIsRemember] = useState<boolean>(true);
    const [message, setMessage] = useState<string>('');

    const {LoginUser} = useActions();
    const navigate = useNavigate();
    const { t } = useTranslation();

    const handleSubmit = async (event: React.FormEvent) => {
        event.preventDefault();
        let data = {email: email, password: password, isRemember};
        try {
            await LoginUser(data);
        } catch {
            setMessage(t("Login.Error", "Wrong email or password!"));
        }
    };

    return (
        <div className={styles.login}>
            <form className={styles.container} onSubmit={handleSubmit}>
                <div className={styles.title}>
                    <div className={styles.titleText}>{t("Login.Title", "LOGIN")}</div>
                </div>

                <div className={styles.field}>
                    <div className={styles.inputGroup}>
                        <label className={styles.label}>{t("Login.EmailLabel", "Username or E-mail")}</label>
                        <input className={styles.input}
                               type="email"
                               value={email}
                               onChange={(e) => setEmail(e.target.value)}
                               required
                        />
                    </div>
                </div>

                <div className={styles.field}>
                    <div className={styles.inputGroup}>
                        <label className={styles.label}>{t("Login.PasswordLabel", "Password")}</label>
                        <input className={styles.input}
                               type="password"
                               value={password}
                               onChange={(e) => setPassword(e.target.value)}
                               required
                        />
                    </div>
                </div>

                {message && <div className={styles.error}>{message}</div>}

                {/*<div className={styles.remember}>*/}
                {/*    <div className={styles.rememberInner}>*/}
                {/*        <input className={styles.checkbox}*/}
                {/*               type="checkbox"*/}
                {/*               id="remember"*/}
                {/*               checked={isRemember}*/}
                {/*               onChange={(e) => setIsRemember(e.target.checked)}*/}
                {/*        />*/}
                {/*        <span className={styles.rememberText}>Запам’ятати мене</span>*/}
                {/*    </div>*/}
                {/*</div>*/}

                <div className={styles.actions}>
                    <div className={styles.actionsInner}>
                        {/*<div className={styles.forgot}>Забули пароль? Звяжіться з Адміністратором!</div>*/}

                        <button type="submit" className={`${styles.button} ${styles.loginButton}`}>
                            <span className={styles.buttonText}>{t("Login.LoginButton", "LOGIN")}</span>
                        </button>

                        <button type="button" className={`${styles.button} ${styles.registerButton}`} onClick={()=> navigate('/register')}>
                            <span className={styles.buttonText}>{t("Login.RegisterButton", "REGISTER")}</span>
                        </button>
                    </div>
                </div>
            </form>
        </div>
    );
};

export default Login;
